<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Pause Subscription</h1>
            </div>

            <div class="modal-body">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="form-field">
                            <label>Pause Subscription Until</label>

                            <simple-date-time-picker
                                v-model="pauseDate">
                            </simple-date-time-picker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>

                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PauseSubscription',
        props: {
            subscription: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                pauseDate: null,
            }
        },
        mounted() {
            //
        },
        methods: {
            saveForm() {
                axios.post(route('subscriptions.pause', this.$route.params.accountId), { ttl: moment(this.pauseDate).format('YYYY-MM-DD') })
                    .then(response => {
                        this.$bus.$emit('alert.success', 'Account subscription has been paused')
                        this.closeView()
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$emit('closing')
                this.setMetaTitle('View Subscription | JournoLink Control')
                this.$root.goBack()
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        }
    }
</script>
